/* STEFANO - packaging premium (product, box, gift-card). Dipende dal selettore dell'app Globo. */
(function () {
  var MODAL_HTML =
    '<div class="packaging-box">' +
    '<span class="packaging-close" role="button" tabindex="0" aria-label="Chiudi">&times;</span>' +
    '<h3 class="packaging-title">Confronto packaging</h3>' +
    '<div class="packaging-table">' +
    '<div class="row header">' +
    '<div class="cell"></div>' +
    '<div class="cell">' +
    '<div class="img-wrapper"><img loading="lazy" alt="Packaging standard" src="https://cdn.shopify.com/s/files/1/0929/8264/1024/files/packaging_panthos.jpg"></div>' +
    '<span class="standard-badge">INCLUSO</span>Standard' +
    '</div>' +
    '<div class="cell">' +
    '<div class="img-wrapper"><img loading="lazy" alt="Packaging premium" src="https://cdn.shopify.com/s/files/1/0929/8264/1024/files/packaging_premium_panthos.jpg"></div>' +
    '<span class="premium-badge">CONSIGLIATO</span>Premium' +
    '</div>' +
    '</div>' +
    '<div class="row"><div class="cell label">Materiale</div><div class="cell">Flessibile</div><div class="cell">Rigido</div></div>' +
    '<div class="row"><div class="cell label">Protezione</div><div class="cell">Base</div><div class="cell">Alta</div></div>' +
    '<div class="row"><div class="cell label">Stile</div><div class="cell">Minimal</div><div class="cell">Elegante</div></div>' +
    '<div class="row"><div class="cell label">Praticità</div><div class="cell">Uso quotidiano</div><div class="cell">Ideale per viaggi</div></div>' +
    '</div>' +
    '<div class="premium-btn-wrap">' +
    '<button type="button" class="premium-add-btn">Voglio ricevere il packaging premium (+2,90€)</button>' +
    '</div>' +
    '</div>';

  var modal;

  function closeModal() {
    modal.style.display = 'none';
  }

  function openModal() {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'packaging-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Confronto packaging');
      modal.innerHTML = MODAL_HTML;
      document.body.appendChild(modal);

      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.closest('.packaging-close')) {
          closeModal();
        } else if (event.target.closest('.premium-add-btn')) {
          var checkbox = document.querySelector('.selettore-packaging-premium input[type="checkbox"]');
          if (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          closeModal();
        }
      });
    }

    modal.style.display = 'flex';
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && modal.style.display === 'flex') closeModal();
  });

  /* Il selettore viene creato (e ricreato) da Globo: aggiunge il "?" quando manca */
  function addTrigger() {
    var selector = document.querySelector('.selettore-packaging-premium');
    if (!selector || selector.querySelector('.packaging-trigger-container')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'packaging-trigger-container';

    var trigger = document.createElement('span');
    trigger.className = 'packaging-trigger';
    trigger.textContent = '?';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-label', 'Confronta i packaging');
    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openModal();
      }
    });

    wrapper.appendChild(trigger);
    selector.appendChild(wrapper);
  }

  var scheduled = false;

  function init() {
    addTrigger();

    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        addTrigger();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
